// src/components/Carregando.js
import React from "react";

// Indicador de carregamento comum às abas Mapa e Sobre.
function Carregando({ texto }) {
  return (
    <div className="carregando" role="status">
      <span className="carregando-trilho" aria-hidden="true">
        <span className="carregando-barra" />
      </span>
      <span className="carregando-texto">{texto}</span>
    </div>
  );
}

export default Carregando;
